import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { filter, truncate, each, find } from 'lodash';
import { Dropdown, MenuItem, Button } from 'react-bootstrap';
import enhanceWithClickOutside from 'react-click-outside';
import Fa from 'react-fontawesome';
import styles from './styles.css';

import { getAccountAutomations, getOpportunityAutomations } from '../../../Setup/SetupReducer';
import { fetchOpportunityAutomationSettings, fetchAccountAutomationSettings } from '../../../Setup/SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getReminderEmailStatus } from '../../../Dashboard/DashboardActions';

class ActionButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      statusLoaded: false,
      statusLoading: false,
      status: null,
      confirmedSendSummaryEmail: null,
      confirmedSendReminderEmail: null,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.close = this.close.bind(this);

    this.requestFeedback = this.requestFeedback.bind(this);
    this.requestExclude = this.requestExclude.bind(this);
    this.requestRunTest = this.requestRunTest.bind(this);
    this.requestSendSummaryEmail = this.requestSendSummaryEmail.bind(this);
    this.requestSendReminderEmail = this.requestSendReminderEmail.bind(this);
    this.requestChangeCommnunicationRecipient = this.requestChangeCommnunicationRecipient.bind(this);
    this.loadData = this.loadData.bind(this);
    this.requestPauseReminderEmail = this.requestPauseReminderEmail.bind(this);
  }



  handleToggle(open, e, s) {
    if (open) {
      this.loadData()
        .then(
          () => {
            this.setState({ 
              open,
              confirmedSendSummaryEmail: null,
              confirmedSendReminderEmail: null,
            });
          },
        );
    } else if (this.state.open && s.source === 'rootClose') {
      this.setState({
        open: false,
        confirmedSendSummaryEmail: null,
        confirmedSendReminderEmail: null,
      });
    }
  }

  loadData() {
    const automationPromise = new Promise((rs, rj) => {
      const { automationLoading, automationLoaded, requestRunTest } = this.props;
      if (requestRunTest) {
        if (!automationLoaded) {
          if (!automationLoading) {
            this.props.fetchAutomations(this.props.organization._id)
              .then(
                () => {
                  // open after loaded
                  rs(true);
                },
                () => {
                  rs(false);
                },
              );
          } else {
            // do nothing, it's loading
            rj();
          }
        } else {
          rs(true);
        }
      } else {
        rs(true);
      }
    });

    const reminderStatusPromise = new Promise((rs, rj) => {
      const { statusLoaded, statusLoading } = this.state;
      if (statusLoaded) {
        rs();
      } else if (!statusLoading) {
        this.setState({ statusLoading: true }, () => {
          const { object, isAccount } = this.props;
          const id = isAccount ? object.account_id : object.opportunity_id;
          this.props.fetchReminderStatus(id)
            .then(
              (status) => {
                this.setState({
                  statusLoading: false,
                  statusLoaded: true,
                  status,
                }, () => {
                  rs(status);
                });
              },
              (e) => {
                rj(e);
              },
            );
        });
      } else {
        rj();
      }
    });

    return Promise.all([automationPromise, reminderStatusPromise]);
  }

  requestRunTest(automation) {
    this.props.requestRunTest(automation);
    this.close();
  }

  requestSendSummaryEmail(automation) {
    if (this.state.confirmedSendSummaryEmail === automation._id) {
      this.props.requestSendSummaryEmail(automation);
      this.close();
    } else {
      this.setState({ confirmedSendSummaryEmail: automation._id, open: true });
    }
  }

  requestSendReminderEmail(automation) {
    if (this.state.confirmedSendReminderEmail === automation._id) {
      this.props.requestSendReminderEmail(automation);
      this.close();
    } else {
      this.setState({ confirmedSendReminderEmail: automation._id, open: true });
    }
  }

  requestChangeCommnunicationRecipient() {
    this.props.requestChangeCommnunicationRecipient();
    this.close();
  }

  requestPauseReminderEmail() {
    const { status } = this.state;
    const isDisabled = status && status.disabled === true;
    this.props.requestPauseReminderEmail(!isDisabled)
      .then(
        (status) => {
          this.setState({ status });
        }
      );
    this.close();
  }


  close() {
    this.setState({
      open: false,
      confirmedSendSummaryEmail: null,
      confirmedSendReminderEmail: null,
    });
  }

  handleClickOutside(e) {
    // this.close(); // for now

    // console.log('click outside', e)
  }


  requestFeedback() {
    this.props.requestFeedback();
    this.close();
  }

  requestExclude() {
    this.props.requestExclude();
    this.close();
  }

  renderCommunicationRecipientMenuItems(label) {
    return (
      <MenuItem key="communication-recipient" onSelect={this.requestChangeCommnunicationRecipient}>{label}</MenuItem>
    );
  }

  renderAutomationMenuItems(dropDownlabel, discoveryBots) {
    const items = [];
    const k = discoveryBots.length > 0 ? `dropdown-${discoveryBots[0].type}` : 'dropdown-';
    let actionHandler = () => {

    };
    let type = null;
    if (discoveryBots[0]?.type === 'automation') {
      type = 'automation';
      actionHandler = this.requestRunTest;
    } else if (discoveryBots[0]?.type === 'summary') {
      type = 'summary';
      actionHandler = this.requestSendSummaryEmail;
    } else if (discoveryBots[0]?.type === 'reminder') {
      type = 'reminder';
      actionHandler = this.requestSendReminderEmail;
    }
    const sureLabel = (
      <span className="text-danger"><Fa name="exclamation-triangle" /> Are you sure?</span>
    );

    if (
      discoveryBots.length === 1 ||
      (type === 'summary' && this.state.confirmedSendSummaryEmail) ||
      (type === 'reminder' && this.state.confirmedSendReminderEmail)
    ) {
      let label = dropDownlabel;
      let eventKey = discoveryBots[0];
      
      if (type === 'summary' && this.state.confirmedSendSummaryEmail) {
        label = sureLabel;
        eventKey = find(discoveryBots, { _id: this.state.confirmedSendSummaryEmail });
      } else if (type === 'reminder' && this.state.confirmedSendReminderEmail) {
        label = sureLabel;
        eventKey = find(discoveryBots, { _id: this.state.confirmedSendReminderEmail });
      }
      items.push((
        <MenuItem key={k} eventKey={eventKey} onSelect={actionHandler}>{label}</MenuItem>
      ));
    } else {
      items.push((
        <Dropdown
          id={k}
          key={k}
          pullRight
          componentClass="li"
        >
          <Dropdown.Toggle>
            <span>{dropDownlabel}</span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {discoveryBots.map((discoveryBot) => {
              let label = truncate(discoveryBot.name, { length: 32 });
              if (type === 'summary' && this.state.confirmedSendSummaryEmail === discoveryBot._id) {
                label = sureLabel;
              } else if (type === 'reminder' && this.state.confirmedSendReminderEmail === discoveryBot._id) {
                label = sureLabel;
              }
              return (
                <MenuItem key={discoveryBot._id} eventKey={discoveryBot} onSelect={actionHandler}>
                  <Fa name="star" className={discoveryBot.is_system ? 'text-warning' : 'invisible'} /> {label}
                </MenuItem>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      ));
    }
    return items;
  }

  render() {
    const { 
      disabled, feedbackRequestStatus,
      requestFeedback, requestExclude,
      automationLoaded, automationLoading, automations,
      enableRunTest, requestRunTest,
      enableReminder,
      enableSummary,
      enableChangeCommnunicationRecipient,
      enablePauseReminderEmail,
    } = this.props;
    const { open, statusLoading, status } = this.state;

    if ((enableRunTest && automationLoading) || (enableReminder && statusLoading)) {
      return (
        <Button bsStyle="default" disabled bsSize="xs">
          Actions <Fa name="spinner" spin />
        </Button>
      );
    };

    const allItems = []; // array of arrays


    const discoveryBots = filter(automations, { type: 'automation' });
    const summaryEmails = filter(automations, { type: 'summary' });
    const reminderEmails = filter(automations, { type: 'reminder' });


    if (feedbackRequestStatus) {
      if (requestFeedback && !feedbackRequestStatus.loading && feedbackRequestStatus.feedbackRequestable) {
        allItems.push([(
          <MenuItem key="request-feedback" onSelect={this.requestFeedback}>Get Feedback</MenuItem>
        )]);
      }
    }

    if (requestRunTest && automationLoaded) {
      const automationItems = [];
      if (enableRunTest && discoveryBots.length > 0) {
        const automationMenuItems = this.renderAutomationMenuItems('Trigger Condition Test', discoveryBots);
        each(automationMenuItems, (automationMenuItem) => {
          automationItems.push(automationMenuItem);
        });
      }
      if (enableSummary && summaryEmails.length > 0) {
        const automationMenuItems = this.renderAutomationMenuItems('Send Summary Email', summaryEmails);
        each(automationMenuItems, (automationMenuItem) => {
          automationItems.push(automationMenuItem);
        });
      }
      if (enableReminder && reminderEmails.length > 0) {
        const automationMenuItems = this.renderAutomationMenuItems('Send Reminder Email', reminderEmails);
        each(automationMenuItems, (automationMenuItem) => {
          automationItems.push(automationMenuItem);
        });

        if (enablePauseReminderEmail) {
          automationItems.push([(
            <MenuItem onSelect={this.requestPauseReminderEmail} key="request-pause-reminder-email">
              <span>{status && status.disabled ? 'Resume Reminder Emails' : 'Pause Reminder Emails'}</span>
            </MenuItem>
          )]);
        }
      }
      if (automationItems.length > 0) {
        allItems.push(automationItems);
      }
    }

    
    if (enableChangeCommnunicationRecipient) {
      allItems.push([this.renderCommunicationRecipientMenuItems('Communication Recipient')]);
    }


    
    

    if (requestExclude && !feedbackRequestStatus.loading && feedbackRequestStatus.hideApexExcludeButton !== true) {
      allItems.push([(
        <MenuItem key="request-exclude" onSelect={this.requestExclude}>Exclude</MenuItem>
      )]);
    }

    const items = [];
    each(allItems, (groupedItems, i) => {
      if (groupedItems.length > 0) {
        if (i > 0) {
          // not first
          items.push((<MenuItem divider key={`request-exclude-div-${i}`} />));
        }
        each(groupedItems, (item) => {
          items.push(item);
        });
      }
    });

    return (
      <Dropdown
        disabled={disabled}
        id="dropdown-actions"
        onToggle={this.handleToggle}
        open={open}
        bsSize="xsmall"
        pullRight
        className={styles.dropdownActions}
      >
        <Dropdown.Toggle disabled={disabled}>
          <span>Actions</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {items}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

ActionButton.propTypes = {
  dispatch: PropTypes.func,
  disabled: PropTypes.bool,
  object: PropTypes.shape({}).isRequired,
  isAccount: PropTypes.bool,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  feedbackRequestStatus: PropTypes.shape({
    loading: PropTypes.bool,
    feedbackRequestable: PropTypes.bool,
    hideApexExcludeButton: PropTypes.bool,
  }),
  requestFeedback: PropTypes.func,
  requestExclude: PropTypes.func,
  enableRunTest: PropTypes.bool,
  enableSummary: PropTypes.bool,
  enableReminder: PropTypes.bool,
  requestRunTest: PropTypes.func,
  enableChangeCommnunicationRecipient: PropTypes.bool,
  requestSendSummaryEmail: PropTypes.func,
  requestSendReminderEmail: PropTypes.func,
  requestChangeCommnunicationRecipient: PropTypes.func,
  automationLoading: PropTypes.bool,
  automationLoaded: PropTypes.bool,
  automations: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  })),
  fetchAutomations: PropTypes.func.isRequired,
  fetchReminderStatus: PropTypes.func.isRequired,
};

ActionButton.defaultProps = {
  disabled: false,
  isAccount: false,
  feedbackRequestStatus: {
    loading: true,
    feedbackRequestable: false,
    hideApexExcludeButton: false,
  },
  requestFeedback: null,
  requestExclude: null,
  requestRunTest: null,
  requestSendSummaryEmail: null,
  requestSendReminderEmail: null,
  requestChangeCommnunicationRecipient: null,
  enableRunTest: false,
  enableSummary: false,
  enableReminder: false,
  automationLoading: false,
  automationLoaded: false,
  enableChangeCommnunicationRecipient: false,
  automations: [],
};

function mapStateToProps(state, ownProps) {
  const isAccount = ownProps.isAccount;
  const settings = isAccount ? getAccountAutomations(state) : getOpportunityAutomations(state);

  return {
    automationLoading: settings.loading === true,
    automationLoaded: settings.loaded === true,
    automations: settings.automations || [],
    organization: getUserCurrentOrganization(state),
  };
}


function mapDispatchToProps(dispatch, ownProps) {
  const { isAccount } = ownProps;
  const fetchAutomations = isAccount ? fetchAccountAutomationSettings : fetchOpportunityAutomationSettings;
  return {
    // dispatching plain actions
    fetchAutomations: (id) => dispatch(fetchAutomations(id)),
    fetchReminderStatus: (id) => dispatch(getReminderEmailStatus(id, isAccount)),
  };
}


// export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithClickOutside(ActionButton));
export default connect(mapStateToProps, mapDispatchToProps)(ActionButton);
